<template>
    <v-layout class="m-form-trades-choose">
        <v-flex sm12 xl12 mt-3>
            <v-card class="pa-3 border-shadow-blue m-form-trades-choose__card">
                <v-layout wrap>
                    <v-flex sm12 md9 lg8 xl8 class="pb-3 m-form-trades-choose__heading">
                        <e-typography-heading-3>Wählen Sie den Typ Ihrer Gewerke aus</e-typography-heading-3>
                    </v-flex>
                    <v-flex sm1 md1 class="m-form-trades-choose__tooltip-box">
                        <m-tooltip-info>
                            {{$t('elements.inputs.e-input-select-business-types.tooltip')}}
                        </m-tooltip-info>
                    </v-flex>
                    <v-flex sm1 md1>
                        <MListBusinessTypesLogo />
                    </v-flex>
                </v-layout>
                <v-data-table
                        :items="businessTypesItems"
                        v-model="selected"
                        item-key="_id"
                        hide-actions
                        hide-headers
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td>
                                <v-checkbox :input-value="props.selected"/>
                            </td>
                            <td v-if="$vuetify.breakpoint.mdAndDown" class="px-0 pt-2 pb-2">
                                <v-flex sm12>
                                    <e-typography-bold>{{props.item.title}}</e-typography-bold>
                                </v-flex>
                                <v-flex sm12 class="m-form-trades-choose__table-description">
                                    <e-typography-body>{{props.item.description}}</e-typography-body>
                                </v-flex>
                            </td>
                            <template v-if="$vuetify.breakpoint.lgAndUp">
                                <td>
                                    <e-typography-bold>{{props.item.title}}</e-typography-bold>
                                </td>
                                <td>
                                    <e-typography-body>{{props.item.description}}</e-typography-body>
                                </td>
                            </template>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

            <m-block-form-buttons
                    :isLoading="$wait.waiting(keys.organizations.update)"
                    class="m-form-trades-choose__btn"
                    context="update"
                    :showCancelButton="false"
                    @submit="submit"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import isEmpty from "lodash/isEmpty";
    import MTooltipInfo from "@modules/tooltips/concrete/m-tooltip-info"
    import {mapActions, mapGetters} from 'vuex';
    import {setRelations} from "@utils/jsonApi";
    import baseForm from "@mixins/components/modules/forms/base";
    import resources from "@mixins/permissions/_resources";
    import ETypographyBold from "@elements/typography/e-typography-bold";
    import ETypographyBody from "@elements/typography/e-typography-body";
    import ETypographyHeading3 from "@elements/typography/e-typography-heading-3";
    import MListBusinessTypesLogo  from "@components/modules/lists/concrete/m-list-business-types-logo";

    export default {
        name: "m-form-trades-choose",
        components: {ETypographyHeading3, ETypographyBody, ETypographyBold, MTooltipInfo, MListBusinessTypesLogo},
        props: {
            name: {
                type: String,
                default: name
            }
        },
        mixins: [baseForm, resources],
        data() {
            return {
                selected: [],
                businessTypesItems: [],
                form: {
                    businessTypes: null
                },
            }
        },
        async created() {
            if (isEmpty(this.organization)) {
                await this.requestOrganization({id: this.organizationId});
            }
            Object.assign(this.form, this.organization);
            await this.requestBusinessTypes();
            let items = [];
            if (!isEmpty(this.businessTypes)) {
                Object.keys(this.businessTypes).forEach((k) => {
                    items.push(this.businessTypes[k])
                });
            }
            this.businessTypesItems = items;
            if (this.organization._jv.relationships && this.organization._jv.relationships.businessType) {
                let allBusinessTypes = this.getActiveTypes(this.organization._jv.relationships.businessType.data.map(t => t.id));

                items.forEach((item) => {
                    let match = allBusinessTypes.filter((b) => b._id == item._id)
                    if (match.length) {
                        this.selected.push(item)
                    } else {
                        item.status = false
                    }
                })
            }
        },
        computed: {
            ...mapGetters({
                businessTypes: 'businessTypes/list',
                getActiveTypes: 'businessTypes/active',
                getOrganization: 'organizations/read'
            }),

            organization() {
                return this.getOrganization(this.organizationId)
            },

            organizationId() {
                return this.$user.relationships.organization.data.id;
            },
            canUpdate() {
                return this.$can(this.$actions.update, this.$abilitySubjects.organization)
            }
        },
        methods: {
            ...mapActions({
                requestOrganization: 'organizations/read',
                updateOrganization: 'organizations/update',
                requestBusinessTypes: 'businessTypes/list'
            }),

            async submit() {
                let businessTypes = {
                    businessType: {
                        data: []
                    }
                };
                this.selected.forEach((item) => {
                    businessTypes.businessType.data.push({
                        type: this.keys.businessTypes.key,
                        id: item._jv.id
                    })
                });

                setRelations(this.form, businessTypes);

                try {
                    await this.updateOrganization(this.form);
                    this.notify.success(this.$t('notifications.profile.editOrganization.edited'));
                } catch (e) {
                    this.error.handle(e);
                }
            },
            cancel() {
                this.goBack();
            }
        }
    }
</script>

<style lang="scss">
    .m-form-trades-choose {
        flex-wrap: wrap;
        .e-typography-bold {
            font-size: 1rem;
        }
        &__heading {
            padding-top: 1.1rem !important;
            padding-left: 1rem !important;

            @include media(md) {
                padding-left: 0;
            }
        }

        .e-typography-body {
            font-size: 1rem;
        }

        &__card {
            @include media(md) {
                margin-bottom: 1rem;
            }
        }
        &__btn {
            padding-top: 1rem !important;
        }
        &__tooltip-box {
            @include media(md) {
                display: contents;
            }
        }
        .m-list-business-types-logo {
            margin-top: .6rem !important;
        }
    }

    .border-shadow-blue {
        box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61)
    }

    .v-datatable {
        margin-top: 1.5rem;

        color: var(--v-tertiary-base);

        .v-input--selection-controls {
            display: flex;
            align-items: center;

            .v-messages {
                display: none;
            }
        }

        .v-input__slot,
        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
            margin: 0;
        }
    }
</style>